"use client";
import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import useAuth from "@/contexts/auth-context";
import IUser from "@/interfaces/user.interface";
import { UsersMessages } from "@/messages/users/user.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { UserTableRow } from "./row";
import { USERS_TABLE_COLUMNS } from "../../constants";

interface UserTableProps {
  data: PaginatedResponse<IUser>;
  pagination: Pagination;
  messages: UsersMessages;
}

export function UserTable({ data, pagination, messages }: UserTableProps) {
  const { pageNumber, pageSize, changePage, extend } = pagination;

  const { user: currentUser } = useAuth();

  const columns = USERS_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {currentUser &&
              data.items.map((user, index) => {
                return (
                  <UserTableRow
                    key={`${index} - ${user.id}`}
                    index={index}
                    user={user}
                    currentUser={currentUser}
                    messages={messages}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, pageNumber) => changePage(pageNumber)}
      />
    </>
  );
}
